import { AutomationTestingProps } from '@/types';

import { DiffViewer } from '@@/CodeEditor/DiffViewer';
import { Loading } from '@@/Widget';
import { Alert } from '@@/Alert';

interface Props extends AutomationTestingProps {
  isCompareReleaseLoading: boolean;
  isCompareReleaseError: boolean;
  newText: string;
  originalText: string;
  id: string;
  originalTitle: string;
  modifiedTitle: string;
  placeholder?: string;
}

export function DiffViewSection({
  isCompareReleaseLoading,
  isCompareReleaseError,
  newText,
  originalText,
  originalTitle,
  modifiedTitle,
  id,
  placeholder = 'No values found',
  'data-cy': dataCy,
}: Props) {
  if (isCompareReleaseLoading) {
    return <Loading />;
  }

  if (isCompareReleaseError) {
    return <Alert color="error">Error loading compare values</Alert>;
  }

  return (
    <DiffViewer
      newCode={newText}
      originalCode={originalText}
      id={id}
      data-cy={dataCy}
      placeholder={placeholder}
      fileNames={{
        original: originalTitle,
        modified: modifiedTitle,
      }}
      className="mt-2"
      type="yaml"
      height="60vh"
    />
  );
}
